import alt from 'components/Dispatcher';

/**
 * Actions that affect the state of the filter word profile page itself, i.e., they do not involve
 * interaction with the server (and so there is no source).
 *
 * The topic editor uses AdminFilterWordProfileActions to interact with the server.
 */
class AdminTopicEditorPageActions {
  constructor() {
    this.generateActions(
      'appendNewAlternateSpelling',
      'deleteAlternateSpellingAtIndex',
      'openTopicNameEditor',
      'resetTopicNameEditor',
      'saveDisplayWhen',
      'saveSpeakerMatch',
      'saveTopicName',
      'setTopicName',
      'setupTopicEditorForExistingTopic',
      'setupTopicEditorForNewTopic',
      'updateAlternateSpellingAtIndex',
      'updateIncludeInInsights',
      'showErrors',
      'hideErrors'
    );
  }
}

export default alt.createActions(AdminTopicEditorPageActions);
